module.exports = __webpack_public_path__ + "img/value-blocks-slider-hyundai.13de104a.png";